<!--
    描述：项目管理 -- 待审核项目- 聚易厅项目审核页
    时间：2022-06-01
    Created by hw
-->
<template>
	<div class="juyi-project-msg-main">
		<div class="expert-content"
			 :class="{ h100: audit === 'audit' }">
			<el-form :model="juyiProjectMsg"
					 label-width="170px"
					 size="small"
					 ref="personForm"
					 :show-message="false">
				<el-row class="mb20">
					<el-col :span="24">
						<span>
							<h2>{{ juyiProjectMsg.sname }}</h2>
						</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="项目类型：">
							{{ juyiProjectMsg.projectTypeName + "/" + juyiProjectMsg.subTypeName }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="上传附件资料：">
              <div class="beyondHiding">
                  <div
                      v-for="(item, index) in juyiProjectMsg.sysFiles"
                      :key="index"
                      class="link mr10"
                      type="text"
                      @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                  >
                    <span slot="reference">{{ item.fileName }}</span>
<!--                    <el-popover
                        placement="top-start"
                        title="文件"
                        trigger="hover"
                    >
                      <div
                          v-for="e in juyiProjectMsg.sysFiles"
                          class="link"
                          :key="e.id"
                          @click="viewFile(e.fullFilePath)"
                      >
                        {{ e.fileName }}
                      </div>
                      <span slot="reference">{{ item.fileName }}</span>
                    </el-popover>-->
                  </div>
              </div>
<!--							<my-upload ref="cns"
									   :aid="juyiProjectMsg.id"
									   :maxNum="1"
									   :tableName="'business_expand_juyi'"
									   mode="view"
									   forDatabase="project_audit"
									   :isDisabled="true">
							</my-upload>-->
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="项目描述：">
							{{ juyiProjectMsg.description }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="发布类型：">
							{{ juyiProjectMsg.pubType === 0 ? "众包" : "" }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="允许投标人数：">
							{{ juyiProjectMsg.allowBids ? juyiProjectMsg.allowBids + '人' : '' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="竞价模式：">
							{{ juyiProjectMsg.bidMode === 0 ? "一口价" : "可议价" }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="报名截止时间：">
							{{ juyiProjectMsg.registrationDeadline ? juyiProjectMsg.registrationDeadline : '' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="项目地址：">
							{{ juyiProjectMsg.projectProvinceName + juyiProjectMsg.projectCityName + juyiProjectMsg.projectAreaName }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="详细地址：">
							{{ juyiProjectMsg.detailAddress }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="雇主报价：">
							{{ juyiProjectMsg.employerOffer ? juyiProjectMsg.employerOffer.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') + '元' : '' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="期望最终交付日期：">
							{{ juyiProjectMsg.exDelDate ? juyiProjectMsg.exDelDate.substring(0, 10) : '' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="分期托管资金：">
							{{ juyiProjectMsg.stageFlag === 0 ? "否" : "是" }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="需要投标方缴纳保证金：">
							{{ juyiProjectMsg.depositFlag === 0 ? "否" : "是" }}
						</el-form-item>
					</el-col>
          <el-col :span="12">
            <el-form-item label="雇主方：">
              {{ juyiProjectMsg.publisherName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要开票：">
              {{ juyiProjectMsg.invoiceFlag === 0 ? "否" : "是" }}
            </el-form-item>
          </el-col>
					<el-col :span="12">
						<el-form-item label="建筑面积：">
							{{ juyiProjectMsg.structureArea ? juyiProjectMsg.structureArea.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') + '平方米' : '' }}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系人手机号：">
							{{ juyiProjectMsg.linkPhone }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="pdl10 pdr10"
			 v-if="audit === 'view'">
			<h3>操作记录：</h3>
			<el-table :data="checkData"
					  class="mt15"
					  height="200px"
					  highlight-current-row
					  row-key="id"
					  border
					  ref="table">
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 width="70"></el-table-column>
				<el-table-column label="操作人"
								 align="center"
								 width="250"
								 prop="createUserName"></el-table-column>
				<el-table-column label="操作时间"
								 align="center"
								 width="250"
								 prop="createDate">
					<template slot-scope="scope">
						<span>{{ scope.row.createDate ? scope.row.createDate.substring(0, 16) : '' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作步骤"
								 align="center"
								 width="250"
								 prop="currentSteps"></el-table-column>
				<el-table-column label="结果"
								 header-align="center"
								 prop="content">
				</el-table-column>
			</el-table>
		</div>
		<div class="footer text-right">
			<el-button size="mini"
					   icon="el-icon-edit-outline"
					   v-if="audit === 'audit'"
					   @click="auditSubmit">审核</el-button>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getProjectMsgByIdForJuyi, getProjectAuditLog } from 'api/modules/projectManagement';
import VUE_CONFIG from "../../../../vue.config";
export default {
	props: {
		rowData: {
			type: Object,
			default: () => {
				return {}
			},
		},
		audit: {
			type: String,
			default: '',
		}
	},
	filters: {
		dateFilter(time) {
			return bmTooljs.dateformat(new Date(time), 'yyyy-MM-dd')
		},
	},
	data() {
		return {
			juyiProjectMsg: {
				id: '',
				baseId: '',
				businessId: '',
				sname: "",
				projectTypeName: "",
				subTypeName: "",
				description: "",
				pubType: "",
				allowBids: "",
				bidMode: '',
				registrationDeadline: "",
				projectProvinceName: "",
				projectCityName: "",
				projectAreaName: "",
				detailAddress: "",
				employerOffer: "",
				exDelDate: "",
				stageFlag: '',
				depositFlag: '',
				structureArea: "",
				linkPhone: "",
				createDate: '',
        publisherName:''
			},
			checkData: [],//操作记录
		}
	},
	created() {
		if (!this.rowData.id) {
			this.$router.push({
				name: 'to-audit-proJect-list',
			})
			return
		}
		//数据加载
		this.getProjectMsgForJuyi()
		if (this.audit === 'view') {
			//操作记录
			this.getProjectAuditLog()
		}
	},
	methods: {
		// 审核
		auditSubmit() {
			let params = {
				id: this.juyiProjectMsg.baseId
			}

			this.$emit('openDia', params)
		},
		//获取聚易厅项目
		getProjectMsgForJuyi() {
			getProjectMsgByIdForJuyi({
				id: this.rowData.id
			}).then(res => {
				if (res.operationCode == '1') {
					this.juyiProjectMsg = res.data.juyiProject
					this.juyiProjectMsg.sname = res.data.msgProject.sname
					this.juyiProjectMsg.createDate = res.data.msgProject.createDate
					this.juyiProjectMsg.publisherName   = res.data.msgProject.publisherName
        }
			})
		},
		//查询审核记录
		getProjectAuditLog() {
			getProjectAuditLog({
				baseId: this.rowData.id
			}).then(res => {
				if (res.operationCode == '1') {
					this.checkData = res.data
				}
			})
		},
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName)
    },
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
}
</script>
<style scoped lang="less">
.juyi-project-msg-main {
	height: 100%;
	.header-note {
		height: 34px;
		line-height: 34px;
		padding: 0 13px;
		border: 1px solid #fbcdd1;
		font-size: 12px;
		color: #e60012;
		background: #fde6e6;
		margin-bottom: 13px;
	}

	.expert-content {
		background-color: #fff;
		padding: 20px;
		height: calc(~'100% - 210px - 20px');
		overflow-y: auto;
		.numblerbox {
			padding: 20px 80px;
			display: flex;
			.numblerboxItem {
				.itembox {
					margin-bottom: 10px;
					.number {
						display: inline-table;
						border-radius: 14px;
						width: 25px;
						height: 25px;
						line-height: 25px;
						text-align: center;
						font-size: 14px;
						vertical-align: middle;
					}
					.blue-bg {
						background-color: #199ed8;
						color: #fff;
					}
					.gray-bg {
						border: 1px solid #999;
						color: #1e1e1e;
					}
					.line {
						margin: 0 4px;
						display: inline-block;
						width: 135px;
						height: 2px;
						// margin-top: 10px;
					}
					.blue-line {
						border-top: 1px solid #199ed8;
					}
					.gray-line {
						border-top: 1px solid #999;
					}
				}
				.descbox {
					text-align: center;
					margin-left: -140px;
					.dec-text {
						font-size: 14px;
					}
					.md5 {
						margin-bottom: 5px;
					}
				}
			}
		}
	}

	.file-row {
		background-color: #fafbfe;
		padding: 15px 0 0;
		margin-bottom: 15px;
	}

	.el-checkbox {
		margin-right: 24px !important;
	}

	.btn-tools {
		position: absolute;
		right: 30px;
		top: 10px;
		z-index: 10;

		.btn-icons {
			display: block;
			width: 40px;
			line-height: 40px;
			height: 40px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			cursor: pointer;
		}

		.red-bg {
			background-color: #f44336;
		}

		.blue-bg {
			background-color: #409eff;
		}
	}

	.menu-block {
		height: 40px;
		line-height: 40px;
		background-color: #fafbfe;
		padding: 0 20px;
		font-size: 14px;
		color: #202020;
		margin-bottom: 10px;

		.text-color {
			font-size: 12px;
			color: #e60012;
			margin-left: 20px;
		}
	}
	.h100 {
		height: 100% !important;
	}
	.download-btn {
		vertical-align: bottom;
		margin-bottom: 18px;
		margin-left: 10px;
	}
}
.footer {
	position: absolute;
	top: 88px;
	right: 135px;
	.el-button {
		height: 28px !important;
	}
}
.asq {
	/deep/ .el-cascader-menu__wrap {
		height: 340px;
	}
}
</style>
